import { Component, h, JSX, Prop } from '@stencil/core';
import { StringService, SvgType } from '../../services';
import { remCalc } from '../../style';
import { TextLinkAppearance, VerticalAlign } from './rcm-text-link.types';
import { Multilink } from '../types/link.types';
import { TrackingService } from '../../services/tracking';
import { TrackingObjectBuilder } from '../../services/tracking/tracking-object-builder';

@Component({
  tag: 'rcm-text-link',
  styleUrl: 'rcm-text-link.scss',
  shadow: true,
})
export class RcmTextLink {
  /** The url the anchor should link to */
  @Prop() public link: string | Multilink;

  /** The optional text inside the anchor */
  @Prop() public text: string;

  /** The aligning of icon and text */
  @Prop() public verticalAlign: VerticalAlign;

  /** A string with with the name of an icon from the icon library */
  @Prop() public icon: SvgType;

  /** Parent Type */
  @Prop({ reflect: true }) type: string;

  /** Is icon on the right side of the link */
  @Prop() iconRight: boolean;

  /** Link parent component */
  @Prop() parentComponent?: string;

  /** Link appeareance */
  @Prop() appeareance?: TextLinkAppearance;

  private handleClick(linkSrc: string) {
    if (this.parentComponent) {
      TrackingService.push(
        new TrackingObjectBuilder()
          .forLinkClick({
            clickText: this.text,
            clickUrl: linkSrc,
            parentComponent: this.parentComponent,
          })
          .build(),
      );
    }
  }

  public render(): JSX.Element {
    const parsedLink = StringService.parseLink(this.link);
    const href = StringService.normalizeLink(parsedLink?.src);
    const linkClasses = {
      link: true,
      'align--baseline': this.verticalAlign === VerticalAlign.BASELINE,
      'direction--reverse': this.iconRight,
      'link--richtext': this.appeareance === TextLinkAppearance.RICHTEXT,
    };

    return (
      <a href={href} target={parsedLink?.target} class={linkClasses} onClick={() => this.handleClick(href)}>
        {this.icon && (
          <div class="icon-container">
            <rcm-icon class="icon" icon={this.icon} height={`${remCalc(16)}rem`}></rcm-icon>
          </div>
        )}
        {this.text}
      </a>
    );
  }
}
